import { type ReactNode, useState } from 'react';
import { getVacationDates } from '@/utils/vacation';
import type { Approacher } from '../types';
import { useClearVacation, useSetVacation } from '../hooks/use-vacation';
import { ActiveStatus, Actions, DateInputs } from './vacation-bar-parts';

const BAR = 'space-y-sm border-t border-white/[0.06] pt-base';

function useVacationState(a: Approacher) {
  const initial = getVacationDates(a);
  const [from, setFrom] = useState(initial.from);
  const [to, setTo] = useState(initial.to);
  return { from, to, setFrom, setTo, hasExisting: !!initial.from };
}

type Props = { a: Approacher; onClose: () => void };

export function VacationBar({ a, onClose }: Props): ReactNode {
  const { from, to, setFrom, setTo, hasExisting } = useVacationState(a);
  const set = useSetVacation();
  const clear = useClearVacation();
  const valid = !!from && !!to && from <= to;
  const pending = set.isPending || clear.isPending;
  return (
    <div className={BAR}>
      <ActiveStatus a={a} />
      <DateInputs from={from} to={to} onFrom={setFrom} onTo={setTo} />
      <Actions
        onCancel={onClose}
        onConfirm={() =>
          set.mutate({ id: a.id, from, to }, { onSuccess: onClose })
        }
        onClear={() => clear.mutate(a.id, { onSuccess: onClose })}
        hasExisting={hasExisting}
        disabled={!valid}
        pending={pending}
      />
    </div>
  );
}
